import React from 'react';

import Wrapper from '../../../hoc/Wrapper/Wrapper';
import Backdrop from '../Backdrop/Backdrop';

import classes from './FormDropdown.module.css';
import enums from '../../../utilities/Enums';
import { IsListEmpty } from '../../../utilities/CommonMethods';

import iconDropdownBlue from '../../../assets/icons/form-dropdown-blue.png';

// Props List :-
// itemList = List of menu items in the dropdown. For eg, [{id: , label:}, ...]
// dropDownOpen = boolean to  represent open/close state of dropdown
// activeItem = selected item from the dropdown list
// onDropDownItemClicked = Handles the click of dropdown item
// onDropDownClicked = Handles the click of dropdown

const formDropDown = (props) => {
    // Log('FormDropdown Props => ', props);
    const itemList = props.itemList.map((item, pos) => {
        return <p
            key={pos}
            className={[classes.DropDownListItem, (pos === props.activeItem) ? classes.Active : null].join(' ')}
            onClick={() => props.onDropDownItemClicked(pos, props.inputIdentifier,item)}>
            {item.label}
        </p>
    });
    return (
        <Wrapper>
            <div className={classes.Backdrop}>
                <Backdrop visible={props.dropDownOpen} transparent={true} backdropClicked={props.onDropDownClicked} />
            </div>
            <div className={[classes.DropDownContainer, props.dropDownOpen ? classes.DropDownOpen : null].join(' ')}>
                <div className={classes.DropDownTopSection} onClick={props.onDropDownClicked}>
                    {
                        (props.activeItem !== undefined && props.activeItem !== '' && props.activeItem >= 0) ?
                        <p className={classes.ActiveLabel}> { props.itemList[props.activeItem].label }</p>
                        :
                        <p className={classes.Label}> </p>
                    }
                    <img
                        className={classes.DropDownIcon}
                        src={iconDropdownBlue}
                        alt="Dropdown Icon"
                    />
                </div>

                <div className={classes.DropDownList}>
                    {
                        !IsListEmpty(itemList) ? itemList
                        :
                        <p className={[classes.DropDownListItem, classes.Active].join(' ')}>No Course Found</p>
                    }

                    {(props.videoType === enums.videoType.CourseEpisode.id && props.inputIdentifier === 'videoSeries') ?
                    <div className={classes.CreateCourseSection}>
                        <hr style={
                            {    
                                marginLeft: '0',
                                boxSizing: 'border-box',
                                marginRight: '0',
                                marginBottom: '16px',
                                marginTop: '0px'
                            }}>    
                        </hr>

                        <p onClick={props.onCreateVideoTitleClick}>Create New Course</p>

                        {!props.videoTitleShow ? null :
                        <div className={classes.CreateCourseForm}>
                            <input className={classes.InputElement} required={true} onChange={props.onCourseTitleChangeListener} type='text' placeholder='Course Title'></input>
                            <span className={classes.CreateButton} onClick={props.onCreateCourseButtonClick}>CREATE</span>
                        </div> }
                    </div> : null }

                    {(props.showRemoveCourse === true) ?
                    <div className={classes.MoveToChannelSection}>
                        <hr></hr>

                        <p onClick={props.onRemoveCourseClick} title="Selecting this option will remove video from the series and it will be treated as a Learning Video">Move to Channel</p>
                    </div> : null }
                </div>
            </div>
        </Wrapper>
    );
}

export default formDropDown;